import api from './api';

const activityLogService = {
  /**
   * Listar logs de actividad con filtros.
   * @param {Object} params - user_id, action, loggable_type, loggable_id, date_from, date_to, search, per_page, page
   */
  getLogs(params = {}) {
    return api.get('/activity-logs', { params }).then((res) => res.data);
  },

  /**
   * Obtener un log por ID.
   */
  getLog(id) {
    return api.get(`/activity-logs/${id}`).then((res) => res.data);
  },

  /**
   * Informe de rendimiento por usuario (conteo de creaciones, ediciones, eliminaciones).
   * @param {Object} params - date_from, date_to, user_id
   */
  getPerformance(params = {}) {
    return api.get('/activity-logs/performance', { params }).then((res) => res.data);
  },
};

export default activityLogService;
